import type { Blueprint } from '../../base/blueprints/Blueprint';
import type { Entry } from '../entries/Entry';

export type ProcessCallback = (blueprint: Blueprint, entry: Entry, blueprintId: number, entryId: number) => Promise<void> | Promise<Record<string, unknown>>;
export const defaultCallback = async (blueprint: Blueprint, entry: Entry, blueprintId: number, entryId: number) => {};
